export const MORNING = 'Good Morning'
export const AFTERNOON = 'Good Afternoon'
export const EVENING = 'Good Evening'
export const DEFAULT_GREETING = 'Hello'

const today = new Date();
const hours = today.getHours();
export const getGreetingText = () => {
  if (hours < 12) return MORNING
  if (hours >= 12 && hours < 17) return AFTERNOON
  if (hours > 17) return EVENING
  return DEFAULT_GREETING
}